<template>
  <svg t="1777274963001" class="icon pointer" viewBox="0 0 1024 1024" version="1.1" fill="#646464" xmlns="http://www.w3.org/2000/svg" p-id="6319" width="16" height="16" @click="$emit('click')">
    <path d="M712.533333 98.133333l213.333334 213.333334c17.066667 17.066667 17.066667 42.666667 0 59.733333l-554.666667 554.666667c-8.533333 8.533333-17.066667 12.8-29.866667 12.8H128c-25.6 0-42.666667-17.066667-42.666667-42.666667v-213.333333c0-12.8 4.266667-21.333333 12.8-29.866667l554.666667-554.666667c17.066667-17.066667 42.666667-17.066667 59.733333 0zM170.666667 853.333333h153.6l512-512L682.666667 187.733333l-512 512V853.333333z" p-id="6320"></path>
  </svg>
</template>

<script>
export default {
  name: 'EditIcon',
  emits: ['click']
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>